import styled from 'styled-components';

const Wrapper = styled.section`
    min-height: 100vh;
    display: grid;
    place-items: center;
`;

export default Wrapper;
